
export const GLOBAL_KEYS = ['consumes', 'produces', 'schemes', 'security'];

export const PATHS_KEY = 'paths';
export const OPERATION_KEYS = ['get', 'post', 'put', 'delete', 'options', 'head', 'patch'];
export const PARAMETERS_KEY = 'parameters';

export const DEFINITIONS_KEY = 'definitions';
export const PROPERTIES_KEY = 'properties';

export const DEFAULT_CONFIG_PATH = '.swagger-diffrc';



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/